import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DesafioEquipoProvider } from '@providers/desafio-equipo/desafio-equipo';
import { EstatusRetosEquipo } from '@domain/estatus.reto.equipo';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { EstatusRetoEnum } from '@domain/estatus.reto.enum';
import { AuthProvider } from '@providers/auth/auth';
import { LocalNotificationProvider } from '@providers/local-notification/local-notification';
import { UserInfoComponent } from '../../../components/user-info/user-info';
import { ExisteGanadorComponent } from '../../../components/existe-ganador/existe-ganador';

@Component({
  selector: 'page-home-tc',
  templateUrl: 'home-tc.html',
  providers: [ DesafioEquipoProvider ]
})
export class HomeTCPage {

  estatus: EstatusRetosEquipo = new EstatusRetosEquipo;
  estatusRequest: Boolean = true;
  jugador: Jugador = new Jugador;
  equipo: Equipo = new Equipo;
  ESTATUS_RETO_ENUM = EstatusRetoEnum;
  tablero: Array<any> = [];
  tableroRequest: Boolean = true;
  show: boolean = false;
  @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
  @ViewChild(ExisteGanadorComponent) existeGanadorComponent: ExisteGanadorComponent;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private localNotificationProvider: LocalNotificationProvider,
    private desafioEquipoProvider: DesafioEquipoProvider
  ) {

  }

  ionViewWillEnter( ) {
    this.initRequest();
  }

  async initRequest(refresher = null) {
    this.estatusRequest = true;
    this.tableroRequest = true;

    try {
      this.jugador = await this.authProvider.getSession();
      this.equipo = await this.authProvider.getEquipo();

      this.getEstatus();
      this.getTablero();

    } catch (e) {
      console.log(e);
    } finally {
      if ( refresher ) {
        refresher.complete();
      }
    }
  }

  private async getTablero() {
    try {
      this.tablero = await this.desafioEquipoProvider.tablero(this.equipo.area._id, this.equipo._id, this.jugador._id);
      if(Array.isArray(this.tablero)){
          this.tablero = this.tablero.sort( (a,b) => b.estadisticas - a.estadisticas);
      }else{
        this.tablero = [];
      }

    } catch(e) {
      console.log(e)
    } finally {
      this.tableroRequest = false;
    }
  }

  private async getEstatus() {
    try {
      this.estatus = await this.desafioEquipoProvider.estatus(this.equipo.area._id, this.equipo._id, this.jugador._id);

      if(this.estatus.estatus === this.ESTATUS_RETO_ENUM.EXISTE_GANADOR) {
        this.authProvider.getWinner()
          .then( winner => {
            if(!winner || this.estatus.ganador.fecha != winner.fecha ) {
              this.show = true;
              this.authProvider.setWinner(this.estatus.ganador);
              setTimeout(() => {
                this.existeGanadorComponent.close.subscribe( (close: boolean) => {
                  this.updateScore();
                });
              });
            }else{
              setTimeout(() => {
                this.existeGanadorComponent.close.subscribe( (close: boolean) => {
                  this.updateScore();
                });
              });
            }
          });
      }

      this.localNotificationProvider.createNotificationTeamChallenge(this.estatus);
    } catch(e) {
      console.log(e)
    } finally {
      this.estatusRequest = false;
    }
  }

  updateScore() {
    this.userInfoComponent.updateScore();
  }

  cerrar() {
    this.authProvider.setWinner(this.estatus.ganador)
    this.show = false;
  }

}



// WEBPACK FOOTER //
// ./src/pages/team-challenge/home-tc/home-tc.ts